// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { JsonRpcError } from "@lib/messaging/rpc/jsonRpc/JsonRpcError";
import { JsonRpcID } from "@lib/messaging/rpc/jsonRpc/JsonRpcID";

/**
 * Represents the result of a JSON-RPC call.
 * Can either contain a result or a value.
 */
export type JsonRpcResponse = {
  jsonrpc: "2.0";
  result: any;
  id: JsonRpcID;
} | {
  jsonrpc: "2.0";
  error: JsonRpcError;
  id: JsonRpcID;
};